import React from 'react';

import { useRouter } from 'next/router';

import SimpleBackdrop from '@client/components/general/SimpleBackdrop';
import SomethingWentWrong from '@client/components/layout/components/SomethingWentWrong';
import { navigationPaths } from '@client/constants/navigation';

import { useAuth } from './AuthContext';

const ProtectedRoute = (props: {
  children: React.ReactNode;
}): JSX.Element | React.ReactNode | any => {
  const router = useRouter();
  const { login } = navigationPaths.public;
  const { loading, error, user } = useAuth();

  if (loading) {
    return <SimpleBackdrop />;
  } else if (error) {
    router.push('/500');
    return <SomethingWentWrong />;
  } else if (user === null) {
    router.push(login);
    return <SimpleBackdrop />;
  } else if (user) {
    return props.children;
  } else {
    return <>{user ? <>{props.children}</> : <SimpleBackdrop />}</>;
  }
};

export default ProtectedRoute;
